<template>
  <Modal
    name="excel-report-modal"
    width="560"
    height="auto"
    title="Download Excel Report"
    para="Choose a date range and optional filters, then generate the file."
  >
    <template #content>
      <div class="excel-report">
        <div class="excel-report__grid">
          <div class="excel-report__field excel-report__field--full">
            <label class="excel-report__label">Date range</label>
            <DateRangePicker
              class="excel-report__datepicker"
              block
              append-to-body
              @update="updateDate"
              opens="right"
            />
          </div>

          <div class="excel-report__field">
            <label class="excel-report__label">Service head</label>
            <Select
              placeholder="All service heads"
              :loading="loading"
              :options="listDoctors"
              :input="updateServiceHead"
              append-to-body
            />
          </div>

          <div class="excel-report__field">
            <label class="excel-report__label">Service name</label>
            <Select
              placeholder="All services"
              :loading="loading"
              :options="serviceOptions"
              :input="updateServiceName"
              append-to-body
            />
          </div>

          <div class="excel-report__field">
            <label class="excel-report__label">Doctor</label>
            <Select
              placeholder="All doctors"
              :loading="loading"
              :options="doctorOptions"
              :input="updateDoctor"
              append-to-body
            />
          </div>

          <div class="excel-report__field">
            <label class="excel-report__label">Invoice number</label>
            <input
              type="text"
              v-model="form.invoice_no"
              placeholder="Optional"
              class="excel-report__input"
              autocomplete="off"
            />
          </div>
        </div>

        <div v-if="downloadUrl" class="excel-report__success">
          <div class="excel-report__success-copy">
            <span class="mdi mdi-check-circle"></span>
            <div>
              <strong>Report ready</strong>
              <p>Your Excel file has been generated.</p>
            </div>
          </div>
          <div class="excel-report__success-actions">
            <a
              :href="downloadUrl.downloadUrl"
              target="_blank"
              class="excel-report__download"
            >
              <span class="mdi mdi-download"></span>
              Download Excel
            </a>
            <button
              type="button"
              class="excel-report__dismiss"
              @click="downloadUrl = null"
            >
              Dismiss
            </button>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="excel-report__actions">
        <button
          type="button"
          class="excel-report__btn excel-report__btn--secondary"
          @click="$modal.hide('excel-report-modal')"
        >
          Cancel
        </button>
        <button
          type="button"
          class="excel-report__btn excel-report__btn--primary"
          @click="generateReport"
          :disabled="loading || !form.start_date || !form.end_date"
        >
          <span v-if="!loading">Generate report</span>
          <span v-else class="excel-report__loader"></span>
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "./Modal.vue";
import DateRangePicker from "./DateRangePIcker.vue";
import Select from "./Select.vue";
import { formatedDate } from "@/utils/helpers";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    Modal,
    DateRangePicker,
    Select
  },
  data() {
    return {
      form: {
        start_date: "",
        end_date: "",
        service_head: null,
        doctor_id: null,
        service_name_id: null,
        invoice_no: "",
        isOther: this.isOther,
        branchId: this.userInfo?.userBranchId || null
      },
      downloadUrl: null
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      listDoctors: "doctors/listDoctors",
      listServices: "services/listItems",
      doctorsList: "receptionist/doctorsList",
      isOther: "auth/isOther",
      userInfo: "auth/userInfo",
      excelReportUrl: "reports/excelReportUrl"
    }),
    serviceOptions() {
      return this.listServices.map(item => ({
        id: item.serviceId,
        name: item.service.name
      }));
    },
    doctorOptions() {
      return this.doctorsList.map(item => ({
        name: item.full_name,
        id: item.id
      }));
    }
  },
  methods: {
    ...mapActions({
      downloadExcelReport: "reports/downloadExcelReport"
    }),
    updateDate(val) {
      this.form.start_date = formatedDate(val.startDate);
      this.form.end_date = formatedDate(val.endDate);
    },
    updateServiceHead(val) {
      this.form.service_head = val?.id || null;
    },
    updateServiceName(val) {
      this.form.service_name_id = val?.id || null;
    },
    updateDoctor(val) {
      this.form.doctor_id = val?.id || null;
    },
    async generateReport() {
      await this.downloadExcelReport(this.form);
      this.downloadUrl = this.excelReportUrl;
    }
  }
};
</script>

<style>
.excel-report {
  display: block;
  padding: 4px 0;
}

.excel-report__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 16px;
  row-gap: 16px;
  align-items: start;
}

.excel-report__field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

.excel-report__field--full {
  grid-column: 1 / -1;
}

.excel-report__field .custom-select,
.excel-report__field .custom-select .v-select,
.excel-report__field .custom-select .select {
  display: block;
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
}

.excel-report__field .custom-select label:empty {
  display: none;
}

.excel-report__label {
  display: block;
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.3;
  color: var(--text, #1f1a2e);
}

.excel-report__datepicker {
  width: 100%;
  margin: 0 !important;
  z-index: 5;
}

.excel-report__datepicker.date-range-picker--block,
.excel-report__datepicker .vue-daterange-picker,
.excel-report__datepicker .reportrange-text {
  width: 100% !important;
  max-width: 100%;
  box-sizing: border-box;
}

.excel-report .custom-select .vs__dropdown-toggle {
  height: 40px !important;
  border-radius: 10px;
  border-color: var(--line-strong, #cdd6e0);
  box-sizing: border-box;
}

.excel-report__input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  box-sizing: border-box;
  border: 1px solid var(--line-strong, #cdd6e0);
  border-radius: 10px;
  background: var(--surface, #fff);
  font-family: var(--font-sans, inherit);
  font-size: 0.9375rem;
  color: var(--text, #1f1a2e);
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  -webkit-appearance: none;
  appearance: none;
}

.excel-report__input::placeholder {
  color: var(--muted-soft, #9a95a8);
}

.excel-report__input:focus {
  border-color: var(--accent-600, #6d54c7);
  box-shadow: 0 0 0 3px rgba(109, 84, 199, 0.15);
}

.excel-report__success {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
  padding: 14px 16px;
  border-radius: 10px;
  background: rgba(46, 125, 50, 0.08);
  border: 1px solid rgba(46, 125, 50, 0.18);
}

.excel-report__success-copy {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.excel-report__success-copy .mdi {
  margin-top: 2px;
  font-size: 1.25rem;
  color: var(--success, #2e7d32);
}

.excel-report__success-copy strong {
  display: block;
  font-size: 0.875rem;
  color: var(--text, #1f1a2e);
}

.excel-report__success-copy p {
  margin: 2px 0 0;
  font-size: 0.8125rem;
  color: var(--muted, #6b657a);
}

.excel-report__success-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.excel-report__download {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  background: var(--grad-accent, var(--accent-600, #6d54c7));
  color: #fff !important;
  text-decoration: none;
  font-size: 0.8125rem;
  font-weight: 600;
}

.excel-report__download .mdi {
  font-size: 1rem;
  color: #fff !important;
}

.excel-report__dismiss {
  height: 36px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--muted, #6b657a);
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
}

.excel-report__dismiss:hover {
  color: var(--text, #1f1a2e);
  background: var(--surface-2, #f4f3f8);
}

.excel-report__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.excel-report__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  height: 40px;
  padding: 0 18px;
  border-radius: 10px;
  font-family: var(--font-sans, inherit);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease, opacity 0.15s ease;
}

.excel-report__btn--secondary {
  border: 1px solid var(--line-strong, #cdd6e0);
  background: #fff;
  color: var(--text, #1f1a2e);
}

.excel-report__btn--secondary:hover {
  background: var(--surface-2, #f4f3f8);
}

.excel-report__btn--primary {
  border: 1px solid transparent;
  background: var(--grad-accent, var(--accent-600, #6d54c7));
  color: #fff;
  box-shadow: 0 2px 8px rgba(109, 84, 199, 0.28);
}

.excel-report__btn--primary span {
  color: #fff !important;
  font-size: inherit !important;
  font-weight: inherit !important;
}

.excel-report__btn--primary:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(109, 84, 199, 0.34);
}

.excel-report__btn--primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}

.excel-report__loader {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  border-radius: 50%;
  animation: excel-report-spin 0.8s linear infinite;
}

@keyframes excel-report-spin {
  to {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 640px) {
  .excel-report__grid {
    grid-template-columns: 1fr;
  }

  .excel-report__field--full {
    grid-column: auto;
  }
}
</style>
